module.exports = __webpack_public_path__ + "static/img/news6detail1.7e871e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news6detail1.jpg
// module id = k/+G
// module chunks = 0